@if (guideLines) {
  <svg:g>
    <svg:line id="myGuideHor"
      class="tooltip guide unmasked"
      x1="0"
      [attr.y1]="posY"
      [attr.x2]="posX"
      [attr.y2]="posY">
      </svg:line>
      <svg:line id="myGuideVer"
        class="tooltip guide unmasked"
        [attr.x1]="posX"
        [attr.y1]="verPosY"
        [attr.x2]="posX"
        [attr.y2]="dimensions.boundedHeight">
        </svg:line>
        </svg:g>
      }
      <svg:g id="myTooltip"
        class="tooltip unmasked"
        [style.transform]="transform">
        <svg:path [attr.d]="borderPath"
          [style.filter]="'url(#shadow)'">
          </svg:path>
          <svg:svg [attr.x]="svgX"
            [attr.y]="svgY">
            <svg:text class="title"
              [attr.x]="((width - offset) / 2)"
              y="20">{{ tooltipData?.title }}
              </svg:text>
              <svg:line [attr.x1]="15"
                y1="30"
                [attr.x2]="width - 15"
                y2="30">
                </svg:line>
                @if (this.tooltipValues.length > 0) {
                  <svg:g>
                    @for (tooltipValue of this.tooltipValues; track tooltipValue; let i = $index) {
                      <svg:g
                        [style.transform]="transformItem[i]">
                        <svg:circle [style.stroke]="tooltipValue.color"
                          [attr.cx]="10"
                          [attr.cy]="0"
                          [attr.r]="radius">
                          </svg:circle>
                          <svg:text x="20"
                            y="4"
                            [style.fill]="tooltipValue.color">
                            {{ tooltipValue.label}}
                            </svg:text>
                            <svg:text [attr.x]="width-50"
                              y="4"
                              text-anchor="end"
                              [style.fill]="tooltipValue.color">
                              {{ formatTick(tooltipValue.value) }}&nbsp;{{ tooltipData.unit }}
                              </svg:text>
                              </svg:g>
                            }
                            </svg:g>
                          }
                          </svg:svg>
                          </svg:g>
